<template>
  <div class="flex py-10 flex-col px-7">
    <!-- <div class="titles py-10" v-if="isFinalAssets">
      <div class="title text-lg font-base mb-2">Final assets</div>
      <div class="subtitle font-base">Here are the final assets shared with you..</div>
    </div>
    <div class="titles py-10" v-if="isWorkingFiles">
      <div class="title text-lg font-base mb-2">Working files</div>
      <div class="subtitle font-base">Discover the working files shared by your producer</div>
    </div> -->
    <AlertInfoBox  v-if="isFinalAssets" message="Use the green button to download all final assets in a zip file, or select the assets you want to download piece by piece."/>
    <AlertCommentBox v-if="description" :message="description"/>
    <div class="list-actions max-w-5xl mx-auto w-full">
      <!-- <div class="select"> -->
      <!-- <ts-link @click="handleSelectAllAssetsClick">Select all</ts-link> -->
      <!-- <ts-link v-show="selectedAssets.length > 0" @click="handleUnselectAllAssetsClick">Unselect all</ts-link> -->
      <!-- </div> -->
      <!-- <div class="actions">
        <ts-button
          :pending="!canDownloadAssets"
          v-if="selectedAssets.length > 0"
          size="small"
          @click="handleDownloadAssetsClick(selectedAssets)"
        >
          Download
        </ts-button>
      </div> -->
    </div>
    <div class="mx-auto max-w-5xl w-full list">
      <div v-for="asset in assets" :key="asset.id" class="row">
        <!-- <ts-checkbox
          class="checkbox"
          :value="isAssetSelected(asset)"
          @input="handleAssetSelectedChange(asset, $event)"
        ></ts-checkbox> -->
        <div class="thumbnail hidden">
          <Thumbnail v-if="asset.file && asset.file.thumbnail" :url="asset.file.thumbnail" />
        </div>
        <div class="file-info">
          <p class="file-name">{{ asset.name }}</p>
          <p class="file-creation-info">Created on {{ formatDate(asset.createdAt) }} by {{ asset.createdBy.name }}</p>
        </div>
        <div class="platforms">
          <PlatformList :platforms="asset.platforms" v-if="isFinalAssets" />
        </div>
        <div class="actions">
          <div class="actions">
            <ts-button size="small" circle @click="handleDownloadAssetClick(asset)" :pending="isPending(asset.status)">
              <ts-icon
                icon="save"
                size="x-small"
                color="#6d7587"
                :title="isPending(asset.status) ? 'Pending' : 'Download'"
              />
            </ts-button>
            <FilePreview
              v-if="isFilePreviewable(asset.file)"
              :file="asset.file"
              :show-edit="false"
              @delete="handleDeleteAssetsClick([asset])"
            />
          </div>
        </div>
      </div>
    </div>
    <div class="mx-auto w-full flex items-center justify-center download-btn-container" v-if="isFinalAssets">
      <ts-button
        :pending="!canDownloadAssets"
        size="large"
        type="primary"
        filled
        @click="handleDownloadAssetsClick(assets)"
      >
        <template > Click here to download all your final assets</template>
      </ts-button>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex';
import { downloadProjectFinalAssets, downloadProjectWorkingFiles } from '@/api/workflow';

import FinalAssetList from '@/views/workflow//delivery/FinalAssetList';
import PlatformList from '@/components/PlatformList.vue';
import AlertCommentBox from "@/components/widgets/AlertCommentBox.vue";
import AlertInfoBox from "@/components/widgets/AlertInfoBox.vue";

import projectViewHelpers from '@/mixins/projectViewHelpers';
export default {
  name: 'DeliverySharedResource',
  mixins: [projectViewHelpers],
  components: {
    AlertCommentBox,
    AlertInfoBox,
    PlatformList,
    FinalAssetList
  },
  props: {
    resource: {
      type: Object,
      required: true
    },
    description: {
      type: String
    },
    token: {
      type: String,
      required: true
    },
    project: {
      type: Object,
      required: true
    }
  },
  data() {
    return {
      selectedAssets: []
    };
  },
  computed: {
    ...mapState('workflow', {
      loadingSharedResource: state => state.sharedResource.loading,
      error: state => state.currentProject.error
    }),
    isFinalAssets() {
      return this.resource.type == 'delivery';
    },
    isWorkingFiles() {
      return this.resource.type == 'working_files';
    },
    canDownloadAssets() {
      return this.selectedAssets.every(asset => {
        return asset.file?.status === 'processed';
      });
    },
    assets() {
      return this.resource ? this.resource.data : [];
    }
  },
  methods: {
    isAssetSelected(asset) {
      return !!this.selectedAssets.find(a => a.id === asset.id);
    },
    handleSelectAllAssetsClick() {
      this.selectedAssets = this.assets;
    },
    handleUnselectAllAssetsClick() {
      this.selectedAssets = [];
    },
    handleAssetSelectedChange(asset, value) {
      if (value) {
        this.selectedAssets = [...this.selectedAssets, asset];
      } else {
        this.selectedAssets = this.selectedAssets.filter(a => a.id !== asset.id);
      }
    },
    handleDownloadAssetsClick(assets) {
      if (!this.canDownloadAssets) {
        window.EventBus.$emit('download.pending');
        return;
      }
      const uploadedAssets = assets.filter(asset => !asset.resumableFile);
      if (uploadedAssets.length > 1) {
        this.showDownloadProcessing();
        if (this.isFinalAssets) {
          this.downloadFile(
            downloadProjectFinalAssets({
              projectId: this.project.id,
              assetIds: uploadedAssets.map(a => a.id)
            }),
            `ts_final_assets_project${this.project.id}.zip`
          );
          return;
        }

        this.downloadFile(
          downloadProjectWorkingFiles({
            projectId: this.project.id,
            assetIds: uploadedAssets.map(a => a.id)
          }),
          `ts_working_files_project${this.project.id}.zip`
        );
        return;
      }

      uploadedAssets.length === 1 && this.handleDownloadAssetClick(uploadedAssets[0]);
    },
    handleDownloadAssetClick(asset) {
      if (this.isPending(asset.status)) {
        window.EventBus.$emit('download.pending');
        return;
      }
      window.open(asset.file.url, '_blank');
    }
  },
  watch: {
    error(value) {
      if (value) {
        this.showError(value);
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.download-btn-container {
  position: fixed;
  bottom: 1.8rem;
  left: 0;
}
.mt-10 {
  margin-top: 2.5rem;
}
.flex {
  display: flex;
}
.items-center {
  align-items: center;
}
.hidden {
  display: none;
}
.font-base {
  font-family: Roboto;
  // font-size: 20px;
  color: #6d7587;
}
.project-status-select {
  margin-left: 100px;
}

.project-info {
  margin-left: 24px;
  flex-grow: 1;

  .project-name {
    font-family: Roboto;
    font-size: 20px;
    color: #6d7587;
  }

  .project-properties {
    font-family: Roboto;
    font-size: 12px;
    line-height: 1.5;
    color: #6d7587;
  }
}

.project-topbar {
  height: 100%;
  display: flex;
  align-items: center;
  padding: 0 26px;
}

.project-details {
  height: 100%;
  display: flex;
  align-items: center;
  flex-grow: 1;
}

.max-w-md {
  max-width: 28rem;
}
.max-w-lg {
  max-width: 32rem;
}
.max-w-xl {
  max-width: 36rem;
}
.max-w-2xl {
  max-width: 42rem;
}
.max-w-3xl {
  max-width: 48rem;
}
.max-w-4xl {
  max-width: 56rem;
}
.max-w-5xl {
  max-width: 64rem;
}
.mx-auto {
  margin-left: auto;
  margin-right: auto;
}
.inset-0 {
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
}
.h-full {
  height: 100%;
}
.w-full {
  width: 100%;
}
.absolute {
  position: absolute;
}
.relative {
  position: relative;
}
.fixed {
  position: fixed;
}
.py-5 {
  padding-top: 1.25rem;
  padding-bottom: 1.25rem;
}
.px-14 {
  padding-left: 3.5rem;
  padding-right: 3.5rem;
}
.py-10 {
  padding-top: 2.5rem;
  padding-bottom: 2.5rem;
}
.pt-20 {
  padding-top: 8.5rem;
}
.pt-10 {
  padding-top: 2.5rem;
}
.opacity-25 {
  opacity: 0.75;
}
.pt-4 {
  padding-top: 1rem;
}
.px-7 {
  padding-left: 1.75rem;
  padding-right: 1.75rem;
}
.w-full {
  width: 100%;
}
.rounded-full {
  border-radius: 30px;
}
.rounded-md {
  border-radius: 10px;
}
.shadow-lg {
  box-shadow: 6px 6px 16px 0 rgba(166, 171, 189, 0.4), -6px -6px 16px 0 rgba(250, 251, 255, 0.4);
}
.shadow-md {
  box-shadow: 2px 2px 6px 0 rgba(166, 171, 189, 0.24);
}
.bg-gradient-gray-500 {
  background-blend-mode: soft-light, normal;
  background-image: linear-gradient(275deg, #000000, white 0%), linear-gradient(to bottom, #ebecf0, #ebecf0);
}
.mb-4 {
  margin-bottom: 1rem;
}
.mb-2 {
  margin-bottom: 0.5rem;
}
.font-semibold {
  font-weight: 500;
}
.font-normal {
  font-weight: normal;
}
.text-lg {
  font-size: 1.25rem;
}
.text-2xl {
  font-size: 1.75rem;
}
.leading-sm {
  line-height: 0.7;
}
.leading-loose {
  line-height: 1.5;
}
.text-md {
  font-size: 0.75rem;
}
.text-gray-500 {
  color: var(--fills-neutral-grey-dark);
}
.flex {
  display: flex;
}
.flex-col {
  flex-direction: column;
}
.justify-center {
  justify-content: center;
}
.items-center {
  align-items: center;
}
.mb-2 {
  margin-bottom: 0.5em;
}
.mt-4 {
  margin-top: 1rem;
}
.flex-1 {
  flex: auto;
}
.flex-none {
  flex: none;
}
.px-2 {
  padding-left: 0.5em;
  padding-right: 0.5em;
}
.font-semibold {
  font-weight: 600;
}
.uppercase {
  text-transform: uppercase;
}
.py-2 {
  padding-top: 0.5em;
  padding-bottom: 0.5em;
}
.justify-between {
  justify-content: space-between;
}
.justify-center {
  justify-content: center;
}
.cursor-pointer {
  cursor: pointer;
}
.grid {
  display: grid;
}
.grid-cols-2 {
  grid-template-columns: 1fr 1fr;
}
.grid-cols-gap-6 {
  column-gap: 1.5rem;
}
.text-center {
  text-align: center;
}
.mb-10 {
  margin-bottom: 2.5rem;
}
.border-1 {
  border: solid 2px rgba(255, 255, 255, 0.16);
}

.list-actions {
  margin-bottom: 20px;
  display: flex;

  .select {
    flex-grow: 1;

    > * {
      margin-right: 23px;
    }
  }

  .actions {
    display: flex;

    > * {
      margin-left: 8px;
    }
  }
}

.droptarget {
  .placeholder {
    display: flex;
    justify-content: center;
    margin: 50px;
  }
}

.row {
  background: #ebecf0;
  background-image: linear-gradient(-42deg, rgba(0, 0, 0, 0.4) 0%, rgba(255, 255, 255, 0.4) 100%);
  background-blend-mode: soft-light, normal;
  background-clip: padding-box;
  border: 2px solid rgba(255, 255, 255, 0.16);
  box-shadow: -2px -2px 6px 0 rgba(250, 251, 255, 0.48), 2px 2px 6px 0 rgba(166, 171, 189, 0.24);
  border-radius: 16px;
  margin-bottom: 10px;

  display: flex;
  align-items: center;
  padding: 12px 18px;

  &.upload-error {
    border-color: #f56c6c;
  }

  // .checkbox {
  //   margin-right: 13px;
  // }

  .thumbnail {
    width: 48px;
    margin-right: 12px;
  }

  .file-info {
    width: 250px;
    padding-right: 12px;

    &.uploading {
      width: auto;
      flex-grow: 1;
    }
  }

  .file-name {
    font-family: Roboto;
    font-size: 12px;
    color: #6d7587;
  }

  .file-creation-info {
    font-family: Roboto;
    font-size: 10px;
    line-height: 16px;
    color: #acbacc;
  }

  .upload-error-message {
    font-family: Roboto;
    font-size: 10px;
    line-height: 16px;
    color: #f56c6c;
  }

  .platforms {
    flex-grow: 1;
  }

  .actions {
    display: flex;
    align-items: center;

    > * {
      margin-left: 10px;
    }
  }
}

.form-row {
  align-items: flex-end;

  .checkbox {
    margin-bottom: 30px;
  }

  .actions {
    margin-bottom: 14px;
  }

  .form-item {
    margin: 0 10px;
  }
}
</style>
